module.exports = {
          srcSet: __webpack_public_path__ + "38bfd5c8ff9bcc703e7fccde41a5d8c1-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "38bfd5c8ff9bcc703e7fccde41a5d8c1-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "38bfd5c8ff9bcc703e7fccde41a5d8c1-79.png",
          toString:function(){return __webpack_public_path__ + "38bfd5c8ff9bcc703e7fccde41a5d8c1-79.png"},
          
          width: 79,
          height: 79
        }